import { CountryUtilType } from "UidispatcherApiModule";
const { CountryUtil }: { CountryUtil: CountryUtilType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default CountryUtil;
